import { PaperclipIcon, PlusIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmAttachmentInput } from '../../../server/dto/crm-attachment-dto.ts';
import { DialogForm } from '../../dialog/dialog-form.tsx';
import { useFileUploader } from '../hooks/use-file-uploader.tsx';
import { FileCard } from './file-card.tsx';

type FileUploaderProps = {
    value: CrmAttachmentInput[];
    onChange: (files: CrmAttachmentInput[]) => void;
    analyticsContext: 'task' | 'note';
};

export function FileUploader({ value, onChange, analyticsContext }: FileUploaderProps): ReactNode {
    const { t } = useLocale('common');
    const { open, remove, edit, download, isReady, uploaderElement } = useFileUploader({
        value,
        onChange,
        analyticsContext,
    });

    if (!isReady) {
        return null;
    }

    return (
        <>
            <DialogForm.Item className="items-center">
                <DialogForm.Label icon={PaperclipIcon}>{t('attachments__label')}</DialogForm.Label>
                <DialogForm.Body>
                    <Button variant="link" icon={PlusIcon} onClick={open} className="p-2">
                        {t('attachments__add_files')}
                    </Button>
                </DialogForm.Body>
            </DialogForm.Item>
            {value.length > 0 && (
                <div className="col-span-2 flex min-w-0 w-full flex-row flex-nowrap gap-2 overflow-x-auto pb-1">
                    {value.map((file) => (
                        <div key={file.externalUuid} className="w-40 shrink-0">
                            <FileCard file={file} onRemove={remove} onEdit={edit} onDownload={download} />
                        </div>
                    ))}
                </div>
            )}
            {uploaderElement}
        </>
    );
}
